import { render, staticRenderFns } from "./noResults.vue?vue&type=template&id=ab25f8c4&scoped=true&"
import script from "./noResults.vue?vue&type=script&lang=js&"
export * from "./noResults.vue?vue&type=script&lang=js&"
import style0 from "./noResults.vue?vue&type=style&index=0&id=ab25f8c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab25f8c4",
  null
  
)

export default component.exports